import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['step']
  static values = { expanded: Boolean }

  connect() {
    this.apply()
  }

  apply() {
    var steps = this.stepTargets;
    for (let step of steps) {
      var stepExpanded = null;
      var htmlValue = step.dataset.stepExpanderExpanded;
      
      if (htmlValue === "true") {
        stepExpanded = true;
      } else if (htmlValue === "false") {
        stepExpanded = false;
      } else {
      var step_expander_id = step.dataset.stepExpanderId;
        var task_id = step.dataset.taskId;
        
        var localStorageValue = null;
        if (task_id) {
          localStorageValue = localStorage.getItem(`task:${task_id}:expanded`);
        }
        if (!localStorageValue && step_expander_id) {
          localStorageValue = localStorage.getItem(step_expander_id);
      }
        
        if (localStorageValue === "true" || localStorageValue === "expanded") {
          stepExpanded = true;
        } else if (localStorageValue === "false" || localStorageValue === "minimized") {
          stepExpanded = false;
        } else {
          stepExpanded = step.classList.contains("expanded");
        }
      }
      
      if (stepExpanded === true) {
        this.expand(step)
      } else if (stepExpanded === false) {
        this.collapse(step)
      }
    }
  }

  expand(step) {
    if (!step) return;
    
    var parent_li = step.closest("li");
    step.classList.add("expanded", "no-drag");
    step.classList.remove("minimized");
    if (parent_li) {
      parent_li.classList.add("expanded", "no-drag");
      parent_li.classList.remove("minimized");
    }
    step.dataset.stepExpanderStatus = "expanded";
    
    var step_expander_id = step.dataset.stepExpanderId;
    var task_id = step.dataset.taskId;
    
    if (task_id) {
      localStorage.setItem(`task:${task_id}:expanded`, "true");
    }
    if (step_expander_id) {
      localStorage.setItem(step_expander_id, "expanded");
    }
  }

  collapse(step) {
    if (!step) return;
    
    var parent_li = step.closest("li");
    step.classList.remove("expanded", "no-drag");
    step.classList.add("minimized");
    if (parent_li) {
      parent_li.classList.remove("expanded", "no-drag");
      parent_li.classList.add("minimized");
    }
    
    var step_title = step.querySelector(".step-title") ?? step.querySelector(".step-title-task");
    if (step_title) {
      step_title.classList.remove("editing");
    }
    
    step.dataset.stepExpanderStatus = "minimized";
    
    var step_expander_id = step.dataset.stepExpanderId;
    var task_id = step.dataset.taskId;
    
    if (task_id) {
      localStorage.setItem(`task:${task_id}:expanded`, "false");
    }
    if (step_expander_id) {
      localStorage.setItem(step_expander_id, "minimized");
    }
  }

  toggle(event) {
    var step = event.target.closest(".step");
    if (!step) return;
    
    var step_expander_id = step.dataset.stepExpanderId;
    var current_status = step.dataset.stepExpanderStatus;
    var parent_li = step.closest("li");
    let accountId = step.dataset.accountId
    let projectId = step.dataset.projectId
    let taskListId = step.dataset.taskListId
    let taskId = step.dataset.taskId

    if (current_status == "expanded") {
      this.collapse(step);
    } else {
      this.expand(step);
    }

    if (accountId && projectId && taskListId && taskId) {
      let expanded = step.dataset.stepExpanderStatus == "expanded" ? true : false

      fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/update_expansion`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
          body: JSON.stringify({ expanded: expanded })
      })
      .then(response => response.json())
      .then(data => {
          if (!data.success) {
              console.error("Failed to update expanded status:", data.errors);
          }
      })
      .catch(error => console.error("Error updating expanded status:", error));
    }
  }

  open(event) {
    var step = event.target.closest(".step");
    if (!step) return;
    
    let accountId = step.dataset.accountId
    let projectId = step.dataset.projectId
    let taskListId = step.dataset.taskListId
    let taskId = step.dataset.taskId
    
    this.expand(step);

    if (accountId && projectId && taskListId && taskId) {
      let expanded = true

      fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/update_expansion`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
          body: JSON.stringify({ expanded: expanded })
      })
      .then(response => response.json())
      .then(data => {
          if (!data.success) {
              console.error("Failed to update expanded status:", data.errors);
          }
      })
      .catch(error => console.error("Error updating expanded status:", error));
    }
  }

  open_all() {
    var closed_steps = this.element.querySelectorAll("li.saved-step:not(.expanded)");
    for (let closed_step of closed_steps) {
      closed_step.querySelector(".expander").click();
    }
  }

  close_all() {
    var open_steps = this.element.querySelectorAll("li.expanded");
    for (let open_step of open_steps) {
      open_step.querySelector(".expander").click();
    }
  }

  update_expansion(accountId, projectId, taskListId, taskId) {
    
  }
}
